module.exports = __webpack_public_path__ + "static/media/great.f43676b5.png";